import { ChildrenWidget } from 'lib-node-amb-renderer';

export class FullPageWithPDFViewerClass extends ChildrenWidget {
  constructor(props) {
    super(props);
  }
}

export { default } from './FullPageWithPDFViewerComponent';
